import { API } from './index';
import { ISendLetterSupport } from '../interfaces';


export function createPaymentYookassa(paymentId: string | undefined | null): Promise<any> {
    return API.get(`/payments/yookassa/create/${paymentId}`);
}

export function yooKassaModalClose(paymentId: string | undefined | null): Promise<any> {
    return API.get(`/payments/yookassa/modal-close/${paymentId}`);
}

export function paymentsProcess(paymentId: string | null): Promise<any> {
    return API.get(`/payments/process/${paymentId}`);
}

export function setPendingPrivatePayment(paymentId: string | null | undefined): Promise<any> {
    return API.get(`/payments/set-pending/${paymentId}`);
}

export function createPaymentStripe(paymentId: string|null|undefined): Promise<any> {
    return API.get(`/payments/stripe/create/${paymentId}`);
}

export function stripeCancellationPayment(stripePaymentId: string, paymentId: string|undefined|null): Promise<any> {
    return API.post('/payments/stripe/cancellation-payment', {
        stripePaymentId,
        paymentId,
    });
}

export function updateMailToReceiveCheck(email: string): Promise<any> {
    return API.post('/payments/update-mail-to-receive-check', { email });
}

export function getUserPayments(project: string | null): Promise<any> {
    const params = project ? `?project=${project}` : '';

    return API.get(`/payments/get-user-payments${params}`);
}

export function getUserPayment(paymentId: string): Promise<any> {
    return API.get(`/payments/get-user-payment?paymentId=${paymentId}`);
}

export function sendLetterSupport(data: ISendLetterSupport) {
    return API.post('/payments/send-letter-support', { data });
}

export function createPaymentYandexPay(paymentId: string): Promise<any> {
    return API.post(`/payments/yandex-pay/create`, { paymentId });
}

export function getUserPaymentData(paymentId: string): Promise<any> {
    return API.get(`/payments/get/${paymentId}`);
}